export default __webpack_public_path__ + "static/media/logo-algolia-blue-35c461b6.badf6a33.svg";